import { useState } from "react"

export const MCP_URL =
  process.env.REACT_APP_MCP_SERVER_URL || "https://mcp.mcp-int.chargeback.io/mcp"

export const CopyBtn = ({ text }) => {
  const [copied, setCopied] = useState(false)
  const handle = () => {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }
  return (
    <button className={`mcp-doc-copy-btn${copied ? " copied" : ""}`} onClick={handle}>
      {copied ? "Copied!" : "Copy"}
    </button>
  )
}

export const CodeBlock = ({ text }) => (
  <div className="mcp-doc-code-block">
    <code>{text}</code>
    <CopyBtn text={text} />
  </div>
)

export const EndpointBox = () => {
  const [copied, setCopied] = useState(false)
  const handle = () => {
    navigator.clipboard.writeText(MCP_URL).then(() => {
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    })
  }
  return (
    <div className="mcp-doc-endpoint-box">
      <span className="mcp-doc-endpoint-url">{MCP_URL}</span>
      <button className="mcp-doc-endpoint-copy" onClick={handle}>
        {!copied && (
          <svg width="12" height="12" viewBox="0 0 20 20" fill="currentColor">
            <path d="M8 2a1 1 0 000 2h2a1 1 0 100-2H8z" />
            <path d="M3 5a2 2 0 012-2 3 3 0 003 3h2a3 3 0 003-3 2 2 0 012 2v6h-4.586l1.293-1.293a1 1 0 00-1.414-1.414l-3 3a1 1 0 000 1.414l3 3a1 1 0 001.414-1.414L10.414 13H15v3a2 2 0 01-2 2H5a2 2 0 01-2-2V5z" />
          </svg>
        )}
        {copied ? "Copied!" : "Copy"}
      </button>
    </div>
  )
}

export const Notice = ({ type, children, style }) => (
  <div className={`mcp-doc-notice${type ? " " + type : ""}`} style={style}>
    {children}
  </div>
)

export const Step = ({ num, title, children }) => (
  <div className="mcp-doc-step">
    <div className="mcp-doc-step-num">{num}</div>
    <div className="mcp-doc-step-content">
      <div className="mcp-doc-step-title">{title}</div>
      {children && <div className="mcp-doc-step-body">{children}</div>}
    </div>
  </div>
)

export const DiscSection = ({ id, openId, onToggle, children }) => (
  <div className="mcp-doc-disc-section">
    <button
      className={`mcp-doc-disc-toggle${openId === id ? " open" : ""}`}
      onClick={() => onToggle(id)}
    >
      <span className="mcp-doc-disc-toggle-label">How to disconnect</span>
      <svg
        className="mcp-doc-disc-chevron"
        width="12"
        height="12"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </button>
    <div className={`mcp-doc-disc-body${openId === id ? " visible" : ""}`}>{children}</div>
  </div>
)
